import React, { useState, useEffect, Fragment } from 'react';
import { PlusOutlined, SettingTwoTone, ExclamationCircleOutlined } from '@ant-design/icons';
import { Table, Row, Modal, Input, message, Button} from "antd";
//import { Button } from "../../component/AuthorityComponent";
// import TagDictMapping from '@/component/TagDictMapping';
import WscDictMapping from "@/component/dictmapping";
import useWscTableList from '@/component/UseWscTableList';
import useWscCustomFormModal from '@/component/UseWscCustomForm';
import useWscCustomColumns from '@/component/UseWscCustomColumns';
import ColumnSettings from '@/component/ColumnSettings';
import useRequest from '@/utils/useRequest';


const { Search } = Input;

const OrderList = (props) => {

  const { request } = useRequest();

  const { showDynamicModal, hide, WscCustomFormModal } = useWscCustomFormModal();
  const { list, isLoading, pagination, setPage, setFilter,filters, setSorter, Refresh } = useWscTableList({ url: "/api/v2/private/orders/list" });
  const { Refresh: refreshColumns, colsettings } = useWscCustomColumns({ key: "order" });
  const [columns, setColumns] = useState([]);
  console.log("list", list)
  useEffect(() => {
    if (colsettings) {
      setColumns(colsettings?.filter(item => item.visible).concat(ExtendColumns));
   
    }
  }, [colsettings]);

  const ExtendColumns = [
    {
      title: <div>操作
        <ColumnSettings topic="order" colsettings={colsettings} list={list} onFinish={refreshColumns} />
      </div>,
      dataIndex: 'id',
      key: 'id',
      render: (id, record) => {
        // console.log('Id, item, idx', Id, idx, item)
        return (<Fragment>
          <Button resId={18} type="link"
            onClick={() => {
              //deepSearch(this.props.areatree,record.AreaId);
              showDynamicModal(66, record);
            }} >修改</Button>
          <Button resId={78}
            //mode={"hide"}
            type='link' onClick={async () => {
              Modal.confirm({
                title: '确认删除',
                icon: <ExclamationCircleOutlined />,
                content: '您确定删除此角色么？',
                onOk: async () => {
                  let result = await request("/api/v2/private/role/delete", "POST", "json", { id: record.Id });
                  if (result.success) {
                    message.success(result.message);
                    Refresh();
                  } else {
                    Modal.error({ content: result.message });
                  }
                },
                okText: '确认',
                cancelText: '取消',
              });

            }}>删除</Button>
        </Fragment>);
      },
    },
  ];

  const handleTableChange = (pagination, _filters, sorter) => {
    setPage(pagination.current);
    setFilter({ ...filters, ..._filters });
    setSorter(sorter);
  }

  return (
    <div style={{ maxHeight: 'calc(100vh - 120px)', overflowY: 'scroll' }} className='bg-white pl-4 pb-4'>
      <div className="flex flex-row mb-6 items-center justify-between">
        <div className="flex flex-row items-center mt-4">
          <span className="text-xl text-gray-800 font-bold mr-6">查询</span>
          <div>
            <Search placeholder="请输入查询内容" onSearch={(val) => {
                  setPage(1);
                  setFilter({ ...filters });
            }} enterButton />
          </div>
        </div>
        <Button className='mr-4 mt-4' onClick={() => {
          setFilter({});
          setPage(1);
        }}>
          重置
        </Button>
      </div>
      <Button resId={77}
        //mode={"hide"} 
        className="mb-6" type="primary" icon={<PlusOutlined />}
        onClick={() => {
          showDynamicModal(65, {});
        }}
      >
        新增
      </Button>
      <Table
        className="m-4"
        rowKey={"Id"}
        loading={isLoading}
        bordered
        dataSource={list}
        columns={columns}
        pagination={{ ...pagination, showTotal: (total) => { return `总数 ${total} 条` } }}
        onChange={handleTableChange}
        size="small"
      />
      <WscCustomFormModal formId={65} OnPayload={(form, name, payload) => {
        console.log(name, payload);
        if (name == "Cancel") {
          hide(65);
          return;
        }
        if (name == "OK") {
          if (payload.apiresult?.success == false) {
            Modal.error({ content: payload.apiresult.message });
            return;
          } else {
            message.success(payload.apiresult?.message);
            hide(65);
            Refresh();
            return;
          }
        }
      }} />

<WscCustomFormModal formId={66}  OnPayload={(form, name, payload) => {
        console.log(name, payload);
        if (name == "Cancel") {
          hide(66);
          return;
        }
        if (name == "OK") {
          if (payload.apiresult?.success == false) {
            Modal.error({ content: payload.apiresult.message });
            return;
          } else {
            message.success(payload.apiresult?.message);
            hide(66);
            Refresh();
            return;
          }
        }
      }} />

    </div>
  );
}


export default OrderList;